/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ShowingRatImport } from './routes/showing-rat'
import { Route as SettingsImport } from './routes/settings'
import { Route as RegisterMembersImport } from './routes/register-members'
import { Route as MapImport } from './routes/map'
import { Route as LeaderboardImport } from './routes/leaderboard'
import { Route as IntroImport } from './routes/intro'
import { Route as HelpImport } from './routes/help'
import { Route as DebugImport } from './routes/debug'
import { Route as CurrentTaskImport } from './routes/current-task'
import { Route as CurrentRoundImport } from './routes/current-round'
import { Route as ChatImport } from './routes/chat'
import { Route as AboutImport } from './routes/about'
import { Route as IndexImport } from './routes/index'
import { Route as RoundsIndexImport } from './routes/rounds/index'
import { Route as RoundsRoundIdIndexImport } from './routes/rounds/$roundId/index'
import { Route as FullscreenVideoRoundIdTaskIdImport } from './routes/fullscreen-video/$roundId/$taskId'
import { Route as ArSceneRoundIdTaskIdImport } from './routes/ar-scene/$roundId/$taskId'
import { Route as RoundsRoundIdTaskTaskIdImport } from './routes/rounds/$roundId/task/$taskId'

// Create/Update Routes

const ShowingRatRoute = ShowingRatImport.update({
  id: '/showing-rat',
  path: '/showing-rat',
  getParentRoute: () => rootRoute,
} as any)

const SettingsRoute = SettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any)

const RegisterMembersRoute = RegisterMembersImport.update({
  id: '/register-members',
  path: '/register-members',
  getParentRoute: () => rootRoute,
} as any)

const MapRoute = MapImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => rootRoute,
} as any)

const LeaderboardRoute = LeaderboardImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => rootRoute,
} as any)

const IntroRoute = IntroImport.update({
  id: '/intro',
  path: '/intro',
  getParentRoute: () => rootRoute,
} as any)

const HelpRoute = HelpImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRoute,
} as any)

const DebugRoute = DebugImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => rootRoute,
} as any)

const CurrentTaskRoute = CurrentTaskImport.update({
  id: '/current-task',
  path: '/current-task',
  getParentRoute: () => rootRoute,
} as any)

const CurrentRoundRoute = CurrentRoundImport.update({
  id: '/current-round',
  path: '/current-round',
  getParentRoute: () => rootRoute,
} as any)

const ChatRoute = ChatImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRoute,
} as any)

const AboutRoute = AboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const RoundsIndexRoute = RoundsIndexImport.update({
  id: '/rounds/',
  path: '/rounds/',
  getParentRoute: () => rootRoute,
} as any)

const RoundsRoundIdIndexRoute = RoundsRoundIdIndexImport.update({
  id: '/rounds/$roundId/',
  path: '/rounds/$roundId/',
  getParentRoute: () => rootRoute,
} as any)

const FullscreenVideoRoundIdTaskIdRoute =
  FullscreenVideoRoundIdTaskIdImport.update({
    id: '/fullscreen-video/$roundId/$taskId',
    path: '/fullscreen-video/$roundId/$taskId',
    getParentRoute: () => rootRoute,
  } as any)

const ArSceneRoundIdTaskIdRoute = ArSceneRoundIdTaskIdImport.update({
  id: '/ar-scene/$roundId/$taskId',
  path: '/ar-scene/$roundId/$taskId',
  getParentRoute: () => rootRoute,
} as any)

const RoundsRoundIdTaskTaskIdRoute = RoundsRoundIdTaskTaskIdImport.update({
  id: '/rounds/$roundId/task/$taskId',
  path: '/rounds/$roundId/task/$taskId',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutImport
      parentRoute: typeof rootRoute
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatImport
      parentRoute: typeof rootRoute
    }
    '/current-round': {
      id: '/current-round'
      path: '/current-round'
      fullPath: '/current-round'
      preLoaderRoute: typeof CurrentRoundImport
      parentRoute: typeof rootRoute
    }
    '/current-task': {
      id: '/current-task'
      path: '/current-task'
      fullPath: '/current-task'
      preLoaderRoute: typeof CurrentTaskImport
      parentRoute: typeof rootRoute
    }
    '/debug': {
      id: '/debug'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof DebugImport
      parentRoute: typeof rootRoute
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpImport
      parentRoute: typeof rootRoute
    }
    '/intro': {
      id: '/intro'
      path: '/intro'
      fullPath: '/intro'
      preLoaderRoute: typeof IntroImport
      parentRoute: typeof rootRoute
    }
    '/leaderboard': {
      id: '/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof LeaderboardImport
      parentRoute: typeof rootRoute
    }
    '/map': {
      id: '/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof MapImport
      parentRoute: typeof rootRoute
    }
    '/register-members': {
      id: '/register-members'
      path: '/register-members'
      fullPath: '/register-members'
      preLoaderRoute: typeof RegisterMembersImport
      parentRoute: typeof rootRoute
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsImport
      parentRoute: typeof rootRoute
    }
    '/showing-rat': {
      id: '/showing-rat'
      path: '/showing-rat'
      fullPath: '/showing-rat'
      preLoaderRoute: typeof ShowingRatImport
      parentRoute: typeof rootRoute
    }
    '/rounds/': {
      id: '/rounds/'
      path: '/rounds'
      fullPath: '/rounds'
      preLoaderRoute: typeof RoundsIndexImport
      parentRoute: typeof rootRoute
    }
    '/ar-scene/$roundId/$taskId': {
      id: '/ar-scene/$roundId/$taskId'
      path: '/ar-scene/$roundId/$taskId'
      fullPath: '/ar-scene/$roundId/$taskId'
      preLoaderRoute: typeof ArSceneRoundIdTaskIdImport
      parentRoute: typeof rootRoute
    }
    '/fullscreen-video/$roundId/$taskId': {
      id: '/fullscreen-video/$roundId/$taskId'
      path: '/fullscreen-video/$roundId/$taskId'
      fullPath: '/fullscreen-video/$roundId/$taskId'
      preLoaderRoute: typeof FullscreenVideoRoundIdTaskIdImport
      parentRoute: typeof rootRoute
    }
    '/rounds/$roundId/': {
      id: '/rounds/$roundId/'
      path: '/rounds/$roundId'
      fullPath: '/rounds/$roundId'
      preLoaderRoute: typeof RoundsRoundIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/rounds/$roundId/task/$taskId': {
      id: '/rounds/$roundId/task/$taskId'
      path: '/rounds/$roundId/task/$taskId'
      fullPath: '/rounds/$roundId/task/$taskId'
      preLoaderRoute: typeof RoundsRoundIdTaskTaskIdImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/chat': typeof ChatRoute
  '/current-round': typeof CurrentRoundRoute
  '/current-task': typeof CurrentTaskRoute
  '/debug': typeof DebugRoute
  '/help': typeof HelpRoute
  '/intro': typeof IntroRoute
  '/leaderboard': typeof LeaderboardRoute
  '/map': typeof MapRoute
  '/register-members': typeof RegisterMembersRoute
  '/settings': typeof SettingsRoute
  '/showing-rat': typeof ShowingRatRoute
  '/rounds': typeof RoundsIndexRoute
  '/ar-scene/$roundId/$taskId': typeof ArSceneRoundIdTaskIdRoute
  '/fullscreen-video/$roundId/$taskId': typeof FullscreenVideoRoundIdTaskIdRoute
  '/rounds/$roundId': typeof RoundsRoundIdIndexRoute
  '/rounds/$roundId/task/$taskId': typeof RoundsRoundIdTaskTaskIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/chat': typeof ChatRoute
  '/current-round': typeof CurrentRoundRoute
  '/current-task': typeof CurrentTaskRoute
  '/debug': typeof DebugRoute
  '/help': typeof HelpRoute
  '/intro': typeof IntroRoute
  '/leaderboard': typeof LeaderboardRoute
  '/map': typeof MapRoute
  '/register-members': typeof RegisterMembersRoute
  '/settings': typeof SettingsRoute
  '/showing-rat': typeof ShowingRatRoute
  '/rounds': typeof RoundsIndexRoute
  '/ar-scene/$roundId/$taskId': typeof ArSceneRoundIdTaskIdRoute
  '/fullscreen-video/$roundId/$taskId': typeof FullscreenVideoRoundIdTaskIdRoute
  '/rounds/$roundId': typeof RoundsRoundIdIndexRoute
  '/rounds/$roundId/task/$taskId': typeof RoundsRoundIdTaskTaskIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/chat': typeof ChatRoute
  '/current-round': typeof CurrentRoundRoute
  '/current-task': typeof CurrentTaskRoute
  '/debug': typeof DebugRoute
  '/help': typeof HelpRoute
  '/intro': typeof IntroRoute
  '/leaderboard': typeof LeaderboardRoute
  '/map': typeof MapRoute
  '/register-members': typeof RegisterMembersRoute
  '/settings': typeof SettingsRoute
  '/showing-rat': typeof ShowingRatRoute
  '/rounds/': typeof RoundsIndexRoute
  '/ar-scene/$roundId/$taskId': typeof ArSceneRoundIdTaskIdRoute
  '/fullscreen-video/$roundId/$taskId': typeof FullscreenVideoRoundIdTaskIdRoute
  '/rounds/$roundId/': typeof RoundsRoundIdIndexRoute
  '/rounds/$roundId/task/$taskId': typeof RoundsRoundIdTaskTaskIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/chat'
    | '/current-round'
    | '/current-task'
    | '/debug'
    | '/help'
    | '/intro'
    | '/leaderboard'
    | '/map'
    | '/register-members'
    | '/settings'
    | '/showing-rat'
    | '/rounds'
    | '/ar-scene/$roundId/$taskId'
    | '/fullscreen-video/$roundId/$taskId'
    | '/rounds/$roundId'
    | '/rounds/$roundId/task/$taskId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/chat'
    | '/current-round'
    | '/current-task'
    | '/debug'
    | '/help'
    | '/intro'
    | '/leaderboard'
    | '/map'
    | '/register-members'
    | '/settings'
    | '/showing-rat'
    | '/rounds'
    | '/ar-scene/$roundId/$taskId'
    | '/fullscreen-video/$roundId/$taskId'
    | '/rounds/$roundId'
    | '/rounds/$roundId/task/$taskId'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/chat'
    | '/current-round'
    | '/current-task'
    | '/debug'
    | '/help'
    | '/intro'
    | '/leaderboard'
    | '/map'
    | '/register-members'
    | '/settings'
    | '/showing-rat'
    | '/rounds/'
    | '/ar-scene/$roundId/$taskId'
    | '/fullscreen-video/$roundId/$taskId'
    | '/rounds/$roundId/'
    | '/rounds/$roundId/task/$taskId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  ChatRoute: typeof ChatRoute
  CurrentRoundRoute: typeof CurrentRoundRoute
  CurrentTaskRoute: typeof CurrentTaskRoute
  DebugRoute: typeof DebugRoute
  HelpRoute: typeof HelpRoute
  IntroRoute: typeof IntroRoute
  LeaderboardRoute: typeof LeaderboardRoute
  MapRoute: typeof MapRoute
  RegisterMembersRoute: typeof RegisterMembersRoute
  SettingsRoute: typeof SettingsRoute
  ShowingRatRoute: typeof ShowingRatRoute
  RoundsIndexRoute: typeof RoundsIndexRoute
  ArSceneRoundIdTaskIdRoute: typeof ArSceneRoundIdTaskIdRoute
  FullscreenVideoRoundIdTaskIdRoute: typeof FullscreenVideoRoundIdTaskIdRoute
  RoundsRoundIdIndexRoute: typeof RoundsRoundIdIndexRoute
  RoundsRoundIdTaskTaskIdRoute: typeof RoundsRoundIdTaskTaskIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  ChatRoute: ChatRoute,
  CurrentRoundRoute: CurrentRoundRoute,
  CurrentTaskRoute: CurrentTaskRoute,
  DebugRoute: DebugRoute,
  HelpRoute: HelpRoute,
  IntroRoute: IntroRoute,
  LeaderboardRoute: LeaderboardRoute,
  MapRoute: MapRoute,
  RegisterMembersRoute: RegisterMembersRoute,
  SettingsRoute: SettingsRoute,
  ShowingRatRoute: ShowingRatRoute,
  RoundsIndexRoute: RoundsIndexRoute,
  ArSceneRoundIdTaskIdRoute: ArSceneRoundIdTaskIdRoute,
  FullscreenVideoRoundIdTaskIdRoute: FullscreenVideoRoundIdTaskIdRoute,
  RoundsRoundIdIndexRoute: RoundsRoundIdIndexRoute,
  RoundsRoundIdTaskTaskIdRoute: RoundsRoundIdTaskTaskIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/about",
        "/chat",
        "/current-round",
        "/current-task",
        "/debug",
        "/help",
        "/intro",
        "/leaderboard",
        "/map",
        "/register-members",
        "/settings",
        "/showing-rat",
        "/rounds/",
        "/ar-scene/$roundId/$taskId",
        "/fullscreen-video/$roundId/$taskId",
        "/rounds/$roundId/",
        "/rounds/$roundId/task/$taskId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/about": {
      "filePath": "about.tsx"
    },
    "/chat": {
      "filePath": "chat.tsx"
    },
    "/current-round": {
      "filePath": "current-round.tsx"
    },
    "/current-task": {
      "filePath": "current-task.tsx"
    },
    "/debug": {
      "filePath": "debug.tsx"
    },
    "/help": {
      "filePath": "help.tsx"
    },
    "/intro": {
      "filePath": "intro.tsx"
    },
    "/leaderboard": {
      "filePath": "leaderboard.tsx"
    },
    "/map": {
      "filePath": "map.tsx"
    },
    "/register-members": {
      "filePath": "register-members.tsx"
    },
    "/settings": {
      "filePath": "settings.tsx"
    },
    "/showing-rat": {
      "filePath": "showing-rat.tsx"
    },
    "/rounds/": {
      "filePath": "rounds/index.tsx"
    },
    "/ar-scene/$roundId/$taskId": {
      "filePath": "ar-scene/$roundId/$taskId.tsx"
    },
    "/fullscreen-video/$roundId/$taskId": {
      "filePath": "fullscreen-video/$roundId/$taskId.tsx"
    },
    "/rounds/$roundId/": {
      "filePath": "rounds/$roundId/index.tsx"
    },
    "/rounds/$roundId/task/$taskId": {
      "filePath": "rounds/$roundId/task/$taskId.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
